import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Layout from '../components/layout';
import Loader from '../components/Loader';
import { useAuth } from '../providers/auth';

export const RequireAuth = () => {
  const { signed, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  return signed ? (
    <Layout>
      <Outlet />
    </Layout>
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};
